import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import type * as EChartsCore from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { EChartsCoreOption } from 'echarts/core';

export const BASE_CHART_CONFIG: EChartsCoreOption = {
  textStyle: {
    fontFamily: 'Oxygen, Arial, sans-serif'
  },
  title: {
    left: 'left',
    textStyle: {
      fontSize: 16,
      fontWeight: 'normal'
    }
  },
  tooltip: {
    trigger: 'axis',
    valueFormatter: (value: unknown) => {
      const numeric = typeof value === 'number' ? value : Number.parseFloat(String(value));
      if (Number.isFinite(numeric)) {
        return numeric.toFixed(4);
      }
      return `${value ?? ''}`;
    }
  },
  grid: {
    top: 60,
    right: 0,
    bottom: 80,
    left: 0,
    containLabel: false
  }
};

@Injectable({ providedIn: 'root' })
export class EchartsLoaderService {
  private readonly platformId = inject(PLATFORM_ID);
  private pending?: Promise<typeof EChartsCore>;

  load(): Promise<typeof EChartsCore | null> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve(null);
    }
    if (!this.pending) {
      this.pending = import('echarts/core').then(core => {
        core.use([LineChart, BarChart, GridComponent, TooltipComponent, TitleComponent, LegendComponent, CanvasRenderer]);
        return core;
      });
    }
    return this.pending;
  }
}